import LocationInterface from '@solvhealth/types/interfaces/Location/index';
import { convertSnakeToCamelCaseRecursive } from '../util/object';

export const getIterableProperties = (accountSummary: any) => accountSummary.iterable_fields || {};

export const analyticsIdentifyIterable = (accountId: any, properties: any) => {
  if (window.analytics) {
    const segmentOptions = {
      integrations: {
        All: false,
        Iterable: true,
      },
    };
    const extendedProperties = {
      ...convertSnakeToCamelCaseRecursive(properties),
      userId: accountId,
    };
    window.analytics.identify(accountId, extendedProperties, segmentOptions);
  }
};

//jpeg is best for emailing, not all clients support webp
export const getLogoForIterable = (location: LocationInterface): string | undefined =>
  location?.imageLinks?.logo_jp2?.[0];
